import { Theme } from '@mui/material/styles';

export type NavModes = 'expanded' | 'collapsed';
const expandedMenuItemStyles =
  (isPadded: boolean = false) =>
  (theme: Theme) => ({
    py: 1.5,
    pl: isPadded ? 16 : 'auto',
    '&.active': {
      bgcolor: `${theme.palette.primary.main}14`,
    },
    '& .MuiListItemIcon-root': {
      minWidth: theme.spacing(14),
    },
  });

const collapsedMenuItemStyles = (theme: Theme) => ({
  py: 1.5,
  marginInline: 0.875,
  justifyContent: 'center',
  minHeight: 'auto',
  '&.active': {
    bgcolor: `${theme.palette.primary.main}14`,
  },
  '& .MuiListItemIcon-root': {
    minWidth: 'auto',
  },
});

function formatEmployerLabel(boardId: string, employerName: string) {
  return `${boardId} - ${employerName}`;
}

export { expandedMenuItemStyles, collapsedMenuItemStyles, formatEmployerLabel };
